// @ts-nocheck
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mvpApi } from '../services/api';
import PostLandingShell from '../components/PostLandingShell';
import { getPathWithRef } from '../utils/attribution';
import { useApplicantFlowPaths } from '../procedures/useApplicantFlowPaths';
import LanguageSwitch from '../components/LanguageSwitch';
import { getCrewParticipantContext, crewFirstName } from '../utils/participantCrewContext';
import { resolveSessionRestorePath, resolveApplicantHubPath, PARTICIPANT_HOME_PATH } from '../utils/postLoginNavigation';
import { persistProcedureSlugFromUser } from '../applicant/utils/procedureOrganizer';
import './Success.css';

const APPLICANT_ENTRY_INTENT_KEY = 'mvp_applicant_entry_intent';

export default function Success() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const paths = useApplicantFlowPaths();
  const crewContext = getCrewParticipantContext();
  const crewName = crewContext ? crewFirstName(crewContext.name) : '';

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      navigate(getPathWithRef(paths.landing), { replace: true });
      return;
    }
    sessionStorage.setItem(APPLICANT_ENTRY_INTENT_KEY, 'signup');
    mvpApi
      .getMe()
      .then((res) => {
        const u = res.data?.user || res.data;
        if (u) localStorage.setItem('userData', JSON.stringify(u));
        persistProcedureSlugFromUser(u);
        const restorePath = resolveSessionRestorePath(u);
        if (restorePath !== PARTICIPANT_HOME_PATH) {
          navigate(restorePath, { replace: true });
        }
      })
      .catch(() => navigate(getPathWithRef(paths.landing)));
  }, [navigate, paths.landing]);

  return (
    <PostLandingShell
      pageClassName="gm-pl-page--success"
      headerAside={<LanguageSwitch />}
      hero={<></>}
      badge={t('successPage.completedBadge')}
      title={crewName ? `You're set up, ${crewName}` : t('successPage.title')}
      subtitle={(
        <p className="gm-pl-subtitle">
          {crewContext
            ? 'Your account is active. Continue to your participant home to finish your production todos.'
            : t('successPage.body')}
        </p>
      )}
      listItems={[]}
      footnote=""
      primaryLabel={crewContext ? 'Go to participant home' : t('successPage.getStarted')}
      onPrimary={() => {
        try {
          const u = JSON.parse(localStorage.getItem('userData') || '{}');
          window.location.assign(resolveApplicantHubPath(u));
        } catch {
          window.location.assign(PARTICIPANT_HOME_PATH);
        }
      }}
      onBrandClick={() => {
        window.location.href = 'https://globalmobility.law/';
      }}
    />
  );
}
